import { useAuth } from "@clerk/react";
import { PropsWithChildren, useEffect, useRef } from "react";
import { appQueryClient } from "@/api";
import { useAuthStore } from "@/store/auth/auth.store";
import { useTenantStore } from "@/store/tenant/tenant.store";
import { websocketService } from "@/services/websocket.service";
import { Initialize } from "@/pages/initialize/initialize";

export function ClerkSession({ children }: PropsWithChildren) {
    const { isLoaded, sessionId, getToken } = useAuth();
    const configuredSession = useAuthStore((state) => state.sessionId);
    const previousSession = useRef<string | null | undefined>(undefined);

    useEffect(() => {
        if (!isLoaded) return;
        const nextSession = sessionId ?? null;
        if (previousSession.current !== nextSession) {
            void appQueryClient.cancelQueries();
            appQueryClient.clear();
            websocketService.disconnect();
            if (previousSession.current !== undefined || nextSession === null) {
                useTenantStore.getState().clearTenantData();
            }
            previousSession.current = nextSession;
        }
        // Remove the old Keycloak token and redirect state from earlier installations.
        localStorage.removeItem("exibra/auth-token");
        localStorage.removeItem("exibra/redirect-url");
        useAuthStore.getState().setSession(nextSession, getToken);
        if (nextSession) websocketService.connect();
        return () => websocketService.disconnect();
    }, [isLoaded, sessionId, getToken]);

    if (!isLoaded || configuredSession !== (sessionId ?? null)) return <Initialize />;
    return children;
}
